/**
 * AppSuite template presets - shared with backend (services/appsuite-template-presets.js)
 * Keep in sync for list/get template structure.
 */

export type TemplateConfigField = {
  key: string
  label: string
  type: 'text' | 'url' | 'image'
  required?: boolean
  defaultValue?: unknown
}

const SMART_HOME_DASHBOARD_V1 = {
  presetId: 'smart-home-dashboard-v1',
  name: 'Smart Home Dashboard v1',
  type: 'dashboard',
  category: 'standard' as const,
  description: 'Minimal dark mobile dashboard with quick scenes and room cards.',
  sections: {
    header: {
      weatherLabel: 'Outside',
      weatherIcon: 'wb_sunny',
      weatherValue: '26°C',
      notificationDot: true,
      avatarImage:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuBjqlgYj-wiMf8iWJlktrWHPPfZ_0HoF1Nq0C96KXDT3Z8idNxXDYe_Tzq_2di50ipQk92DGdpIWx8g-to-WjaFeHxU9YyzRa5y0D5QPISh2OaQZajVSNRRUoHLlV4BLzizEUDkBFu7n6frY0iIiKYYoNEAbJH9WbLO7v8ZSfqRup10na3-wTP5YHJXewpaVV6mMboFgscIqEK8uvscdvaH3iJ02IH1sSwKc1k0Go-SNpO-JONNx_r1HCbncH2a_jaRSix3Z_qkHQq5',
    },
    quickScenes: [
      { id: 'movie-night', label: 'Movie Night', icon: 'movie', active: true },
      { id: 'away', label: 'Away', icon: 'directions_run', active: false },
      { id: 'sleep', label: 'Sleep', icon: 'dark_mode', active: false },
    ],
    homeCards: [
      {
        id: 'bedroom-ac',
        title: 'Bedroom AC',
        subtitle: 'Cooling • Off',
        enabled: false,
        image:
          'https://lh3.googleusercontent.com/aida-public/AB6AXuDKdQ5_hJZ_EvRjiV3Y4wEQcwJm62u-hNzu5YmUGvHT63gDSSuHPi1lkhnAq3xW1PNIevbfvmqiUSMgOo6buaeh9kbkwoSpSUxisruU5AKVnyB8Lwp4wIRHNmvPF0qdvgTji4JflFyJte1X6E5C8zZw2Ec2fivYQzG_AWhw-hQFkT612vpdWxekTzPf9uDA7b-NmJX0EK8KIsisXYjeW9ZEDN9fiwk1veOOjl-_0sswjKOcJx1MPh0qW-IvJ8-_1AzNm75jgmvIkUPV',
      },
      {
        id: 'living-room',
        title: 'Living Room',
        subtitle: 'Light • On',
        enabled: true,
        image:
          'https://lh3.googleusercontent.com/aida-public/AB6AXuB1bg0BeV5jsfMH44q1KRHmeEpAjnRTexupV9o10Hqzw4GdRNhwbshYzoFwgvLjgbDY2WE9ZvRHEmpbWrNFQisgmAYy1us--l8DV-gT-QSkb_s8oWfT8yai_N2YFu9gVINBDJIrOb6zjXUYzZBM9Ztc2UN4SO5AroC-NcacUGxdU371q6A76CSGKywuk_LCruP_MrJwzhK2cQzfXv6lf2yozO6AeclDLt3G2SBZ2nQ4-Oi7ZUu6vAzdaPeIYbLfnwIDoMyoXXY5Qj',
      },
      {
        id: 'smart-plug',
        title: 'Smart Plug',
        subtitle: 'Coffee Maker • On',
        enabled: true,
        image:
          'https://lh3.googleusercontent.com/aida-public/AB6AXuBledewyRrpeYpqMa12C_mNeMUaw0D8oN97wHi3PbvhPOVZOl8E4iHmNa-aqa-4ZQc7RkvqLMWk4JWNrdcwCDAQvqSl3wS2k3zWGAFUtcbQEXxvaWI1WDmVJrjvZhE0bVZ5fJwf_6LOhGiL5BGQ3eG3eaFQNAFqSsDlGyVLrjQUywngoUgNQr5q_NIIck4stsM0itHfoccKNKqpQwUs4vh9OfsWfo1LFil071RdhScfLYgtj4JtYxDXO22pz2yg8nKo-kNvnaRmEIk4',
      },
      {
        id: 'front-door',
        title: 'Front Door',
        subtitle: 'Camera • Standby',
        enabled: false,
        image:
          'https://lh3.googleusercontent.com/aida-public/AB6AXuAnO5UrJSuEqW_3Tqw7rX0rTPJudwyx_F2qx1EvoE9hbBk09fMABud60aTV2J4ZKhn0iywqc_tN3RgiXeWOzAwH6rWqPYZHJiiJbJxts1aKC6QS9MPgPkv8sRCv20NzVxdWShtaEqV8bSSBuC1uYUd9ElF3e1AN1vQKndbY_o-TYqp7qlBYWIkKvYVgaYY1_gjlDoZCgNUb_1zFgU9sgT7X6qlyUcRuArHiD8m6FvCp5z78aA-10RSl0iGk5ocGfPDlWc4KA3DHct1T',
      },
    ],
    bottomNav: [
      { id: 'home', label: 'Home', icon: 'home', active: true },
      { id: 'auto', label: 'Smart', icon: 'auto_awesome', active: false },
      { id: 'store', label: 'Store', icon: 'shopping_bag', active: false },
    ],
    headerBrand: '奥创智慧',
    floatingAction: { icon: 'add' },
    card: {
      defaultConfig: { enabledTraits: [], enabledAttributes: [], enabledStates: [] },
      deviceTypes: {
        ac_unit: { enabledTraits: [], enabledAttributes: [], enabledStates: [] },
        hvac: { enabledTraits: [], enabledAttributes: [], enabledStates: [] },
      },
    },
    modal: {
      defaultConfig: {
        enabledTraits: ['OnOff', 'Brightness'],
        enabledAttributes: [],
        enabledStates: [],
        componentOrder: ['OnOff', 'Brightness'],
        hiddenComponents: [],
        modalTraitStyles: { OnOff: 'Style01', Brightness: 'Style01' },
        modalAttributeStyles: {},
      },
      deviceTypes: {
        ac_unit: {
          modalStyleId: 'Style01',
          enabledTraits: [],
          enabledAttributes: [],
          enabledStates: [],
          componentOrder: [],
          hiddenComponents: [],
          modalTraitStyles: {},
          modalAttributeStyles: {},
        },
        hvac: {
          enabledTraits: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          enabledAttributes: [],
          enabledStates: [],
          componentOrder: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          hiddenComponents: [],
          modalTraitStyles: {
            OnOff: 'Style01',
            ThermostatSetMode: 'Style01',
            TemperatureSetting: 'Style05',
            FanSpeed: 'Style01',
          },
          modalAttributeStyles: {},
        },
      },
    },
  },
  brandConfigSchema: [
    { key: 'brandName', label: 'Brand Name', type: 'text' as const, required: true },
    { key: 'loginBg', label: 'Login Background Image', type: 'image' as const },
  ] satisfies TemplateConfigField[],
  templateConfigSchema: [
    { key: 'dashboardBg', label: 'Dashboard Background', type: 'image' as const },
    { key: 'storeLink', label: 'Store URL', type: 'url' as const },
  ] satisfies TemplateConfigField[],
  styles: {
    tokens: {
      colors: {
        background: '#0B1120',
        backgroundAccent: '#1E293B',
        cardGlass: 'rgba(255,255,255,0.05)',
        cardBorder: 'rgba(255,255,255,0.10)',
        textPrimary: '#FFFFFF',
        textMuted: 'rgba(255,255,255,0.60)',
        primary: '#FBBF24',
      },
      radius: { sceneCard: 24, roomCard: 32, navPill: 40 },
      spacing: { pageX: 24, pageTop: 56, sectionGap: 28 },
    },
    typography: { fontFamily: 'Inter, sans-serif', titleWeight: 700, bodyWeight: 600 },
  },
}

const ENVIRONMENTAL_COMFORT_V1 = {
  presetId: 'environmental-comfort-v1',
  name: 'Environmental Comfort v1',
  type: 'dashboard',
  category: 'standard' as const,
  description: 'Light-themed environmental monitoring dashboard focused on comfort metrics, air quality and HVAC control.',
  sections: {
    header: {
      avatarImage: '',
      weatherLabel: 'TAIPEI',
      weatherIcon: 'thermostat',
      weatherValue: '',
      notificationDot: false,
    },
    comfortThresholds: {
      temperature: { min: 24, max: 26, unit: '°C' },
      humidity: { min: 40, max: 60, unit: '%' },
      co2: { max: 1000, unit: 'ppm' },
      tvoc: { max: 500, unit: 'ppb' },
      pm25: { max: 35, unit: 'µg/m³' },
    },
    bottomNav: [
      { id: 'home', label: 'Home', icon: 'home', active: true },
      { id: 'auto', label: 'Smart', icon: 'auto_awesome', active: false },
      { id: 'store', label: 'Store', icon: 'storefront', active: false },
    ],
    headerBrand: 'Comfort',
    login: { styleId: 'redesigned-sign-in' },
    modal: {
      defaultConfig: {
        enabledTraits: ['OnOff'],
        enabledAttributes: [],
        enabledStates: [],
        componentOrder: ['OnOff'],
        hiddenComponents: [],
        modalTraitStyles: { OnOff: 'Style01' },
        modalAttributeStyles: {},
      },
      deviceTypes: {
        ac_unit: {
          enabledTraits: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          enabledAttributes: [],
          enabledStates: [],
          componentOrder: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          hiddenComponents: [],
          modalTraitStyles: {
            OnOff: 'Style01',
            ThermostatSetMode: 'Style01',
            TemperatureSetting: 'Style05',
            FanSpeed: 'Style01',
          },
          modalAttributeStyles: {},
        },
        hvac: {
          enabledTraits: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          enabledAttributes: [],
          enabledStates: [],
          componentOrder: ['OnOff', 'ThermostatSetMode', 'TemperatureSetting', 'FanSpeed'],
          hiddenComponents: [],
          modalTraitStyles: {
            OnOff: 'Style01',
            ThermostatSetMode: 'Style01',
            TemperatureSetting: 'Style05',
            FanSpeed: 'Style01',
          },
          modalAttributeStyles: {},
        },
      },
    },
    card: {
      defaultConfig: { enabledTraits: [], enabledAttributes: [], enabledStates: [] },
      deviceTypes: {},
    },
  },
  brandConfigSchema: [
    { key: 'brandName', label: 'Brand Name', type: 'text' as const, required: true },
    { key: 'loginBg', label: 'Login Background Image', type: 'image' as const },
  ] satisfies TemplateConfigField[],
  templateConfigSchema: [
    { key: 'dashboardBg', label: 'Dashboard Background', type: 'image' as const },
    { key: 'storeLink', label: 'Store URL', type: 'url' as const },
  ] satisfies TemplateConfigField[],
  styles: {
    tokens: {
      colors: {
        background: '#f8fafb',
        backgroundAccent: '#ffffff',
        cardGlass: 'rgba(255,255,255,0.72)',
        cardBorder: 'rgba(148,163,184,0.15)',
        textPrimary: '#1e293b',
        textMuted: '#64748b',
        primary: '#10b981',
      },
      radius: { sceneCard: 16, roomCard: 20, navPill: 40 },
      spacing: { pageX: 20, pageTop: 48, sectionGap: 20 },
    },
    typography: {
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      titleWeight: 700,
      bodyWeight: 500,
    },
  },
}

const ACUO_APP_V1 = {
  presetId: 'acuo-app-v1',
  name: 'Acuo App V1 (Standalone)',
  type: 'dashboard' as const,
  category: 'standalone' as const,
  description: 'Device-centric watercolor dashboard with swipeable device carousel and inline monolithic modal content.',
  sections: {
    header: { brandName: 'ACUO' },
    store: { storeLink: 'http://store.ultronsmart.com' },
    bottomNav: [
      { id: 'devices', label: 'Devices', icon: 'grid_view', active: true },
      { id: 'store', label: 'Store', icon: 'storefront' },
      { id: 'profile', label: 'Profile', icon: 'person' },
    ],
  },
  brandConfigSchema: [
    { key: 'brandName', label: 'Brand Name', type: 'text' as const, required: true, defaultValue: 'ACUO' },
    { key: 'loginBg', label: 'Login Background Image', type: 'image' as const },
  ] satisfies TemplateConfigField[],
  templateConfigSchema: [
    { key: 'dashboardBg', label: 'Dashboard Background', type: 'image' as const },
    { key: 'storeLink', label: 'Store URL', type: 'url' as const },
  ] satisfies TemplateConfigField[],
}

const PRESETS: Record<string, typeof SMART_HOME_DASHBOARD_V1> = {
  [SMART_HOME_DASHBOARD_V1.presetId]: SMART_HOME_DASHBOARD_V1,
  [ENVIRONMENTAL_COMFORT_V1.presetId]: ENVIRONMENTAL_COMFORT_V1 as unknown as typeof SMART_HOME_DASHBOARD_V1,
  [ACUO_APP_V1.presetId]: ACUO_APP_V1 as unknown as typeof SMART_HOME_DASHBOARD_V1,
}

const PRESET_ALIASES: Record<string, string> = {
  'smart-home-v1': 'smart-home-dashboard-v1',
  'acuo-v1': 'acuo-app-v1',
}

export function listTemplatePresets() {
  return Object.values(PRESETS).map((item) => ({
    presetId: item.presetId,
    name: item.name,
    type: item.type,
    description: item.description,
  }))
}

export function getTemplatePreset(presetId: string) {
  const id = String(presetId || '').trim()
  const resolved = PRESET_ALIASES[id] || id
  return PRESETS[resolved] || null
}
